module.exports = __webpack_public_path__ + "img/sdg15.e4ab6437.svg";